import adjustmentRoutes from '@/view/pages/einvoice/adjustment/router';

const einvoiceRoutes = [
  {
    path: '/einvoice',
    redirect: '/einvoices',
  },
  {
    path: '/einvoices',
    component: () =>
      import(
        /* webpackChunkName: "einvoice" */
        '@/view/pages/einvoice/EInvoice.vue'
      ),
    children: [
      {
        path: '/',
        name: 'einvoice-list',
        component: () =>
          import(
            /* webpackChunkName: "einvoice" */
            '@/view/pages/einvoice/List.vue'
          ),
        meta: {
          title: 'Hoá đơn điện tử',
        },
      },
      {
        path: 'config',
        name: 'einvoice-config',
        component: () =>
          import(
            /* webpackChunkName: "einvoice-config" */
            '@/view/pages/einvoice/Config.vue'
          ),
        meta: {
          title: 'Cấu hình hoá đơn điện tử',
        },
      },
      ...adjustmentRoutes,
      {
        path: ':salesInvoiceId',
        name: 'einvoice-detail',
        component: () =>
          import(
            /* webpackChunkName: "einvoice" */
            '@/view/pages/einvoice/Detail.vue'
          ),
        meta: {
          title: 'Chi tiết hoá đơn điện tử',
        },
      },
    ],
  },
];

export default einvoiceRoutes;
